export default "__VITE_ASSET__B3WZr0tx__"